/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getProgramDerivedAddress,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
  SolanaError,
  transformEncoder,
  type AccountMeta,
  type AccountSignerMeta,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type Instruction,
  type InstructionWithAccounts,
  type InstructionWithData,
  type ReadonlyAccount,
  type ReadonlyUint8Array,
  type TransactionSigner,
  type WritableAccount,
  type WritableSignerAccount,
} from '@solana/kit';
import {
  getAccountMetaFactory,
  getAddressFromResolvedInstructionAccount,
  type ResolvedInstructionAccount,
} from '@solana/program-client-core';
import { DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS } from '../programs';

export const SETTLE_FEES_DISCRIMINATOR = new Uint8Array([
  60, 221, 130, 229, 183, 234, 6, 159,
]);

export function getSettleFeesDiscriminatorBytes() {
  return fixEncoderSize(getBytesEncoder(), 8).encode(SETTLE_FEES_DISCRIMINATOR);
}

export type SettleFeesInstruction<
  TProgram extends string = typeof DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS,
  TAccountSettlementAuthority extends string | AccountMeta<string> = string,
  TAccountInitializerProgram extends string | AccountMeta<string> =
    '4h3Dqyo5qmteJoMxXt3tdtfXELDB6pdRTPU9mWruiKp1',
  TAccountInitializerConfig extends string | AccountMeta<string> = string,
  TAccountLaunch extends string | AccountMeta<string> = string,
  TAccountLaunchFeeState extends string | AccountMeta<string> = string,
  TAccountLaunchAuthority extends string | AccountMeta<string> = string,
  TAccountBaseMint extends string | AccountMeta<string> = string,
  TAccountQuoteMint extends string | AccountMeta<string> = string,
  TAccountBaseVault extends string | AccountMeta<string> = string,
  TAccountQuoteVault extends string | AccountMeta<string> = string,
  TAccountRehypeState extends string | AccountMeta<string> = string,
  TAccountRehypeAuthority extends string | AccountMeta<string> = string,
  TAccountSettlementSigner extends string | AccountMeta<string> = string,
  TAccountRouterBaseAta extends string | AccountMeta<string> = string,
  TAccountRouterQuoteAta extends string | AccountMeta<string> = string,
  TAccountBuybackDestination extends string | AccountMeta<string> = string,
  TAccountBuybackBaseAta extends string | AccountMeta<string> = string,
  TAccountBuybackQuoteAta extends string | AccountMeta<string> = string,
  TAccountNamespace extends string | AccountMeta<string> = string,
  TAccountHookConfig extends string | AccountMeta<string> = string,
  TAccountHookProgram extends string | AccountMeta<string> = string,
  TAccountBaseTokenProgram extends string | AccountMeta<string> = string,
  TAccountQuoteTokenProgram extends string | AccountMeta<string> = string,
  TAccountAssociatedTokenProgram extends string | AccountMeta<string> =
    'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL',
  TAccountSystemProgram extends string | AccountMeta<string> =
    '11111111111111111111111111111111',
  TAccountGateCosigner extends string | AccountMeta<string> = string,
  TAccountCosignGateControl extends string | AccountMeta<string> = string,
  TRemainingAccounts extends readonly AccountMeta<string>[] = [],
> = Instruction<TProgram> &
  InstructionWithData<ReadonlyUint8Array> &
  InstructionWithAccounts<
    [
      TAccountSettlementAuthority extends string
        ? WritableSignerAccount<TAccountSettlementAuthority> &
            AccountSignerMeta<TAccountSettlementAuthority>
        : TAccountSettlementAuthority,
      TAccountInitializerProgram extends string
        ? ReadonlyAccount<TAccountInitializerProgram>
        : TAccountInitializerProgram,
      TAccountInitializerConfig extends string
        ? ReadonlyAccount<TAccountInitializerConfig>
        : TAccountInitializerConfig,
      TAccountLaunch extends string
        ? WritableAccount<TAccountLaunch>
        : TAccountLaunch,
      TAccountLaunchFeeState extends string
        ? WritableAccount<TAccountLaunchFeeState>
        : TAccountLaunchFeeState,
      TAccountLaunchAuthority extends string
        ? ReadonlyAccount<TAccountLaunchAuthority>
        : TAccountLaunchAuthority,
      TAccountBaseMint extends string
        ? ReadonlyAccount<TAccountBaseMint>
        : TAccountBaseMint,
      TAccountQuoteMint extends string
        ? ReadonlyAccount<TAccountQuoteMint>
        : TAccountQuoteMint,
      TAccountBaseVault extends string
        ? WritableAccount<TAccountBaseVault>
        : TAccountBaseVault,
      TAccountQuoteVault extends string
        ? WritableAccount<TAccountQuoteVault>
        : TAccountQuoteVault,
      TAccountRehypeState extends string
        ? WritableAccount<TAccountRehypeState>
        : TAccountRehypeState,
      TAccountRehypeAuthority extends string
        ? ReadonlyAccount<TAccountRehypeAuthority>
        : TAccountRehypeAuthority,
      TAccountSettlementSigner extends string
        ? ReadonlyAccount<TAccountSettlementSigner>
        : TAccountSettlementSigner,
      TAccountRouterBaseAta extends string
        ? WritableAccount<TAccountRouterBaseAta>
        : TAccountRouterBaseAta,
      TAccountRouterQuoteAta extends string
        ? WritableAccount<TAccountRouterQuoteAta>
        : TAccountRouterQuoteAta,
      TAccountBuybackDestination extends string
        ? ReadonlyAccount<TAccountBuybackDestination>
        : TAccountBuybackDestination,
      TAccountBuybackBaseAta extends string
        ? WritableAccount<TAccountBuybackBaseAta>
        : TAccountBuybackBaseAta,
      TAccountBuybackQuoteAta extends string
        ? WritableAccount<TAccountBuybackQuoteAta>
        : TAccountBuybackQuoteAta,
      TAccountNamespace extends string
        ? ReadonlyAccount<TAccountNamespace>
        : TAccountNamespace,
      TAccountHookConfig extends string
        ? ReadonlyAccount<TAccountHookConfig>
        : TAccountHookConfig,
      TAccountHookProgram extends string
        ? ReadonlyAccount<TAccountHookProgram>
        : TAccountHookProgram,
      TAccountBaseTokenProgram extends string
        ? ReadonlyAccount<TAccountBaseTokenProgram>
        : TAccountBaseTokenProgram,
      TAccountQuoteTokenProgram extends string
        ? ReadonlyAccount<TAccountQuoteTokenProgram>
        : TAccountQuoteTokenProgram,
      TAccountAssociatedTokenProgram extends string
        ? ReadonlyAccount<TAccountAssociatedTokenProgram>
        : TAccountAssociatedTokenProgram,
      TAccountSystemProgram extends string
        ? ReadonlyAccount<TAccountSystemProgram>
        : TAccountSystemProgram,
      TAccountGateCosigner extends string
        ? ReadonlyAccount<TAccountGateCosigner>
        : TAccountGateCosigner,
      TAccountCosignGateControl extends string
        ? ReadonlyAccount<TAccountCosignGateControl>
        : TAccountCosignGateControl,
      ...TRemainingAccounts,
    ]
  >;

export type SettleFeesInstructionData = {
  discriminator: ReadonlyUint8Array;
  minBaseToQuoteOut: bigint;
  minQuoteToBaseOut: bigint;
};

export type SettleFeesInstructionDataArgs = {
  minBaseToQuoteOut: number | bigint;
  minQuoteToBaseOut: number | bigint;
};

export function getSettleFeesInstructionDataEncoder(): FixedSizeEncoder<SettleFeesInstructionDataArgs> {
  return transformEncoder(
    getStructEncoder([
      ['discriminator', fixEncoderSize(getBytesEncoder(), 8)],
      ['minBaseToQuoteOut', getU64Encoder()],
      ['minQuoteToBaseOut', getU64Encoder()],
    ]),
    (value) => ({ ...value, discriminator: SETTLE_FEES_DISCRIMINATOR }),
  );
}

export function getSettleFeesInstructionDataDecoder(): FixedSizeDecoder<SettleFeesInstructionData> {
  return getStructDecoder([
    ['discriminator', fixDecoderSize(getBytesDecoder(), 8)],
    ['minBaseToQuoteOut', getU64Decoder()],
    ['minQuoteToBaseOut', getU64Decoder()],
  ]);
}

export function getSettleFeesInstructionDataCodec(): FixedSizeCodec<
  SettleFeesInstructionDataArgs,
  SettleFeesInstructionData
> {
  return combineCodec(
    getSettleFeesInstructionDataEncoder(),
    getSettleFeesInstructionDataDecoder(),
  );
}

export type SettleFeesAsyncInput<
  TAccountSettlementAuthority extends string = string,
  TAccountInitializerProgram extends string = string,
  TAccountInitializerConfig extends string = string,
  TAccountLaunch extends string = string,
  TAccountLaunchFeeState extends string = string,
  TAccountLaunchAuthority extends string = string,
  TAccountBaseMint extends string = string,
  TAccountQuoteMint extends string = string,
  TAccountBaseVault extends string = string,
  TAccountQuoteVault extends string = string,
  TAccountRehypeState extends string = string,
  TAccountRehypeAuthority extends string = string,
  TAccountSettlementSigner extends string = string,
  TAccountRouterBaseAta extends string = string,
  TAccountRouterQuoteAta extends string = string,
  TAccountBuybackDestination extends string = string,
  TAccountBuybackBaseAta extends string = string,
  TAccountBuybackQuoteAta extends string = string,
  TAccountNamespace extends string = string,
  TAccountHookConfig extends string = string,
  TAccountHookProgram extends string = string,
  TAccountBaseTokenProgram extends string = string,
  TAccountQuoteTokenProgram extends string = string,
  TAccountAssociatedTokenProgram extends string = string,
  TAccountSystemProgram extends string = string,
  TAccountGateCosigner extends string = string,
  TAccountCosignGateControl extends string = string,
> = {
  settlementAuthority: TransactionSigner<TAccountSettlementAuthority>;
  initializerProgram?: Address<TAccountInitializerProgram>;
  initializerConfig: Address<TAccountInitializerConfig>;
  launch: Address<TAccountLaunch>;
  launchFeeState: Address<TAccountLaunchFeeState>;
  launchAuthority: Address<TAccountLaunchAuthority>;
  baseMint: Address<TAccountBaseMint>;
  quoteMint: Address<TAccountQuoteMint>;
  baseVault: Address<TAccountBaseVault>;
  quoteVault: Address<TAccountQuoteVault>;
  rehypeState?: Address<TAccountRehypeState>;
  rehypeAuthority?: Address<TAccountRehypeAuthority>;
  settlementSigner?: Address<TAccountSettlementSigner>;
  routerBaseAta?: Address<TAccountRouterBaseAta>;
  routerQuoteAta?: Address<TAccountRouterQuoteAta>;
  buybackDestination: Address<TAccountBuybackDestination>;
  buybackBaseAta: Address<TAccountBuybackBaseAta>;
  buybackQuoteAta: Address<TAccountBuybackQuoteAta>;
  namespace: Address<TAccountNamespace>;
  hookConfig: Address<TAccountHookConfig>;
  hookProgram: Address<TAccountHookProgram>;
  baseTokenProgram: Address<TAccountBaseTokenProgram>;
  quoteTokenProgram: Address<TAccountQuoteTokenProgram>;
  associatedTokenProgram?: Address<TAccountAssociatedTokenProgram>;
  systemProgram?: Address<TAccountSystemProgram>;
  gateCosigner?: Address<TAccountGateCosigner>;
  cosignGateControl?: Address<TAccountCosignGateControl>;
  minBaseToQuoteOut: SettleFeesInstructionDataArgs['minBaseToQuoteOut'];
  minQuoteToBaseOut: SettleFeesInstructionDataArgs['minQuoteToBaseOut'];
};

export async function getSettleFeesInstructionAsync<
  TAccountSettlementAuthority extends string,
  TAccountInitializerProgram extends string,
  TAccountInitializerConfig extends string,
  TAccountLaunch extends string,
  TAccountLaunchFeeState extends string,
  TAccountLaunchAuthority extends string,
  TAccountBaseMint extends string,
  TAccountQuoteMint extends string,
  TAccountBaseVault extends string,
  TAccountQuoteVault extends string,
  TAccountRehypeState extends string,
  TAccountRehypeAuthority extends string,
  TAccountSettlementSigner extends string,
  TAccountRouterBaseAta extends string,
  TAccountRouterQuoteAta extends string,
  TAccountBuybackDestination extends string,
  TAccountBuybackBaseAta extends string,
  TAccountBuybackQuoteAta extends string,
  TAccountNamespace extends string,
  TAccountHookConfig extends string,
  TAccountHookProgram extends string,
  TAccountBaseTokenProgram extends string,
  TAccountQuoteTokenProgram extends string,
  TAccountAssociatedTokenProgram extends string,
  TAccountSystemProgram extends string,
  TAccountGateCosigner extends string,
  TAccountCosignGateControl extends string,
  TProgramAddress extends Address =
    typeof DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS,
>(
  input: SettleFeesAsyncInput<
    TAccountSettlementAuthority,
    TAccountInitializerProgram,
    TAccountInitializerConfig,
    TAccountLaunch,
    TAccountLaunchFeeState,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountRehypeState,
    TAccountRehypeAuthority,
    TAccountSettlementSigner,
    TAccountRouterBaseAta,
    TAccountRouterQuoteAta,
    TAccountBuybackDestination,
    TAccountBuybackBaseAta,
    TAccountBuybackQuoteAta,
    TAccountNamespace,
    TAccountHookConfig,
    TAccountHookProgram,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountAssociatedTokenProgram,
    TAccountSystemProgram,
    TAccountGateCosigner,
    TAccountCosignGateControl
  >,
  config?: { programAddress?: TProgramAddress },
): Promise<
  SettleFeesInstruction<
    TProgramAddress,
    TAccountSettlementAuthority,
    TAccountInitializerProgram,
    TAccountInitializerConfig,
    TAccountLaunch,
    TAccountLaunchFeeState,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountRehypeState,
    TAccountRehypeAuthority,
    TAccountSettlementSigner,
    TAccountRouterBaseAta,
    TAccountRouterQuoteAta,
    TAccountBuybackDestination,
    TAccountBuybackBaseAta,
    TAccountBuybackQuoteAta,
    TAccountNamespace,
    TAccountHookConfig,
    TAccountHookProgram,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountAssociatedTokenProgram,
    TAccountSystemProgram,
    TAccountGateCosigner,
    TAccountCosignGateControl
  >
> {
  // Program address.
  const programAddress =
    config?.programAddress ?? DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    settlementAuthority: {
      value: input.settlementAuthority ?? null,
      isWritable: true,
    },
    initializerProgram: {
      value: input.initializerProgram ?? null,
      isWritable: false,
    },
    initializerConfig: {
      value: input.initializerConfig ?? null,
      isWritable: false,
    },
    launch: { value: input.launch ?? null, isWritable: true },
    launchFeeState: { value: input.launchFeeState ?? null, isWritable: true },
    launchAuthority: {
      value: input.launchAuthority ?? null,
      isWritable: false,
    },
    baseMint: { value: input.baseMint ?? null, isWritable: false },
    quoteMint: { value: input.quoteMint ?? null, isWritable: false },
    baseVault: { value: input.baseVault ?? null, isWritable: true },
    quoteVault: { value: input.quoteVault ?? null, isWritable: true },
    rehypeState: { value: input.rehypeState ?? null, isWritable: true },
    rehypeAuthority: {
      value: input.rehypeAuthority ?? null,
      isWritable: false,
    },
    settlementSigner: {
      value: input.settlementSigner ?? null,
      isWritable: false,
    },
    routerBaseAta: { value: input.routerBaseAta ?? null, isWritable: true },
    routerQuoteAta: { value: input.routerQuoteAta ?? null, isWritable: true },
    buybackDestination: {
      value: input.buybackDestination ?? null,
      isWritable: false,
    },
    buybackBaseAta: { value: input.buybackBaseAta ?? null, isWritable: true },
    buybackQuoteAta: { value: input.buybackQuoteAta ?? null, isWritable: true },
    namespace: { value: input.namespace ?? null, isWritable: false },
    hookConfig: { value: input.hookConfig ?? null, isWritable: false },
    hookProgram: { value: input.hookProgram ?? null, isWritable: false },
    baseTokenProgram: {
      value: input.baseTokenProgram ?? null,
      isWritable: false,
    },
    quoteTokenProgram: {
      value: input.quoteTokenProgram ?? null,
      isWritable: false,
    },
    associatedTokenProgram: {
      value: input.associatedTokenProgram ?? null,
      isWritable: false,
    },
    systemProgram: { value: input.systemProgram ?? null, isWritable: false },
    gateCosigner: { value: input.gateCosigner ?? null, isWritable: false },
    cosignGateControl: {
      value: input.cosignGateControl ?? null,
      isWritable: false,
    },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Original args.
  const args = { ...input };

  // Resolve default values.
  if (!accounts.initializerProgram.value) {
    accounts.initializerProgram.value =
      '4h3Dqyo5qmteJoMxXt3tdtfXELDB6pdRTPU9mWruiKp1' as Address<'4h3Dqyo5qmteJoMxXt3tdtfXELDB6pdRTPU9mWruiKp1'>;
  }
  if (!accounts.rehypeState.value) {
    accounts.rehypeState.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([
            114, 101, 104, 121, 112, 101, 95, 115, 116, 97, 116, 101,
          ]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'baseMint',
            accounts.baseMint.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.rehypeAuthority.value) {
    accounts.rehypeAuthority.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([
            114, 101, 104, 121, 112, 101, 95, 97, 117, 116, 104, 111, 114, 105,
            116, 121,
          ]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'rehypeState',
            accounts.rehypeState.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.settlementSigner.value) {
    accounts.settlementSigner.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([
            115, 101, 116, 116, 108, 101, 109, 101, 110, 116, 95, 115, 105, 103,
            110, 101, 114,
          ]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'rehypeState',
            accounts.rehypeState.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.routerBaseAta.value) {
    accounts.routerBaseAta.value = await getProgramDerivedAddress({
      programAddress:
        'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL' as Address<'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'>,
      seeds: [
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'rehypeAuthority',
            accounts.rehypeAuthority.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'baseTokenProgram',
            accounts.baseTokenProgram.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'baseMint',
            accounts.baseMint.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.routerQuoteAta.value) {
    accounts.routerQuoteAta.value = await getProgramDerivedAddress({
      programAddress:
        'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL' as Address<'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'>,
      seeds: [
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'rehypeAuthority',
            accounts.rehypeAuthority.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'quoteTokenProgram',
            accounts.quoteTokenProgram.value,
          ),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'quoteMint',
            accounts.quoteMint.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.associatedTokenProgram.value) {
    accounts.associatedTokenProgram.value =
      'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL' as Address<'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'>;
  }
  if (!accounts.systemProgram.value) {
    accounts.systemProgram.value =
      '11111111111111111111111111111111' as Address<'11111111111111111111111111111111'>;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('settlementAuthority', accounts.settlementAuthority),
      getAccountMeta('initializerProgram', accounts.initializerProgram),
      getAccountMeta('initializerConfig', accounts.initializerConfig),
      getAccountMeta('launch', accounts.launch),
      getAccountMeta('launchFeeState', accounts.launchFeeState),
      getAccountMeta('launchAuthority', accounts.launchAuthority),
      getAccountMeta('baseMint', accounts.baseMint),
      getAccountMeta('quoteMint', accounts.quoteMint),
      getAccountMeta('baseVault', accounts.baseVault),
      getAccountMeta('quoteVault', accounts.quoteVault),
      getAccountMeta('rehypeState', accounts.rehypeState),
      getAccountMeta('rehypeAuthority', accounts.rehypeAuthority),
      getAccountMeta('settlementSigner', accounts.settlementSigner),
      getAccountMeta('routerBaseAta', accounts.routerBaseAta),
      getAccountMeta('routerQuoteAta', accounts.routerQuoteAta),
      getAccountMeta('buybackDestination', accounts.buybackDestination),
      getAccountMeta('buybackBaseAta', accounts.buybackBaseAta),
      getAccountMeta('buybackQuoteAta', accounts.buybackQuoteAta),
      getAccountMeta('namespace', accounts.namespace),
      getAccountMeta('hookConfig', accounts.hookConfig),
      getAccountMeta('hookProgram', accounts.hookProgram),
      getAccountMeta('baseTokenProgram', accounts.baseTokenProgram),
      getAccountMeta('quoteTokenProgram', accounts.quoteTokenProgram),
      getAccountMeta('associatedTokenProgram', accounts.associatedTokenProgram),
      getAccountMeta('systemProgram', accounts.systemProgram),
      getAccountMeta('gateCosigner', accounts.gateCosigner),
      getAccountMeta('cosignGateControl', accounts.cosignGateControl),
    ],
    data: getSettleFeesInstructionDataEncoder().encode(
      args as SettleFeesInstructionDataArgs,
    ),
    programAddress,
  } as SettleFeesInstruction<
    TProgramAddress,
    TAccountSettlementAuthority,
    TAccountInitializerProgram,
    TAccountInitializerConfig,
    TAccountLaunch,
    TAccountLaunchFeeState,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountRehypeState,
    TAccountRehypeAuthority,
    TAccountSettlementSigner,
    TAccountRouterBaseAta,
    TAccountRouterQuoteAta,
    TAccountBuybackDestination,
    TAccountBuybackBaseAta,
    TAccountBuybackQuoteAta,
    TAccountNamespace,
    TAccountHookConfig,
    TAccountHookProgram,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountAssociatedTokenProgram,
    TAccountSystemProgram,
    TAccountGateCosigner,
    TAccountCosignGateControl
  >);
}

export type SettleFeesInput<
  TAccountSettlementAuthority extends string = string,
  TAccountInitializerProgram extends string = string,
  TAccountInitializerConfig extends string = string,
  TAccountLaunch extends string = string,
  TAccountLaunchFeeState extends string = string,
  TAccountLaunchAuthority extends string = string,
  TAccountBaseMint extends string = string,
  TAccountQuoteMint extends string = string,
  TAccountBaseVault extends string = string,
  TAccountQuoteVault extends string = string,
  TAccountRehypeState extends string = string,
  TAccountRehypeAuthority extends string = string,
  TAccountSettlementSigner extends string = string,
  TAccountRouterBaseAta extends string = string,
  TAccountRouterQuoteAta extends string = string,
  TAccountBuybackDestination extends string = string,
  TAccountBuybackBaseAta extends string = string,
  TAccountBuybackQuoteAta extends string = string,
  TAccountNamespace extends string = string,
  TAccountHookConfig extends string = string,
  TAccountHookProgram extends string = string,
  TAccountBaseTokenProgram extends string = string,
  TAccountQuoteTokenProgram extends string = string,
  TAccountAssociatedTokenProgram extends string = string,
  TAccountSystemProgram extends string = string,
  TAccountGateCosigner extends string = string,
  TAccountCosignGateControl extends string = string,
> = {
  settlementAuthority: TransactionSigner<TAccountSettlementAuthority>;
  initializerProgram?: Address<TAccountInitializerProgram>;
  initializerConfig: Address<TAccountInitializerConfig>;
  launch: Address<TAccountLaunch>;
  launchFeeState: Address<TAccountLaunchFeeState>;
  launchAuthority: Address<TAccountLaunchAuthority>;
  baseMint: Address<TAccountBaseMint>;
  quoteMint: Address<TAccountQuoteMint>;
  baseVault: Address<TAccountBaseVault>;
  quoteVault: Address<TAccountQuoteVault>;
  rehypeState: Address<TAccountRehypeState>;
  rehypeAuthority: Address<TAccountRehypeAuthority>;
  settlementSigner: Address<TAccountSettlementSigner>;
  routerBaseAta: Address<TAccountRouterBaseAta>;
  routerQuoteAta: Address<TAccountRouterQuoteAta>;
  buybackDestination: Address<TAccountBuybackDestination>;
  buybackBaseAta: Address<TAccountBuybackBaseAta>;
  buybackQuoteAta: Address<TAccountBuybackQuoteAta>;
  namespace: Address<TAccountNamespace>;
  hookConfig: Address<TAccountHookConfig>;
  hookProgram: Address<TAccountHookProgram>;
  baseTokenProgram: Address<TAccountBaseTokenProgram>;
  quoteTokenProgram: Address<TAccountQuoteTokenProgram>;
  associatedTokenProgram?: Address<TAccountAssociatedTokenProgram>;
  systemProgram?: Address<TAccountSystemProgram>;
  gateCosigner?: Address<TAccountGateCosigner>;
  cosignGateControl?: Address<TAccountCosignGateControl>;
  minBaseToQuoteOut: SettleFeesInstructionDataArgs['minBaseToQuoteOut'];
  minQuoteToBaseOut: SettleFeesInstructionDataArgs['minQuoteToBaseOut'];
};

export function getSettleFeesInstruction<
  TAccountSettlementAuthority extends string,
  TAccountInitializerProgram extends string,
  TAccountInitializerConfig extends string,
  TAccountLaunch extends string,
  TAccountLaunchFeeState extends string,
  TAccountLaunchAuthority extends string,
  TAccountBaseMint extends string,
  TAccountQuoteMint extends string,
  TAccountBaseVault extends string,
  TAccountQuoteVault extends string,
  TAccountRehypeState extends string,
  TAccountRehypeAuthority extends string,
  TAccountSettlementSigner extends string,
  TAccountRouterBaseAta extends string,
  TAccountRouterQuoteAta extends string,
  TAccountBuybackDestination extends string,
  TAccountBuybackBaseAta extends string,
  TAccountBuybackQuoteAta extends string,
  TAccountNamespace extends string,
  TAccountHookConfig extends string,
  TAccountHookProgram extends string,
  TAccountBaseTokenProgram extends string,
  TAccountQuoteTokenProgram extends string,
  TAccountAssociatedTokenProgram extends string,
  TAccountSystemProgram extends string,
  TAccountGateCosigner extends string,
  TAccountCosignGateControl extends string,
  TProgramAddress extends Address =
    typeof DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS,
>(
  input: SettleFeesInput<
    TAccountSettlementAuthority,
    TAccountInitializerProgram,
    TAccountInitializerConfig,
    TAccountLaunch,
    TAccountLaunchFeeState,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountRehypeState,
    TAccountRehypeAuthority,
    TAccountSettlementSigner,
    TAccountRouterBaseAta,
    TAccountRouterQuoteAta,
    TAccountBuybackDestination,
    TAccountBuybackBaseAta,
    TAccountBuybackQuoteAta,
    TAccountNamespace,
    TAccountHookConfig,
    TAccountHookProgram,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountAssociatedTokenProgram,
    TAccountSystemProgram,
    TAccountGateCosigner,
    TAccountCosignGateControl
  >,
  config?: { programAddress?: TProgramAddress },
): SettleFeesInstruction<
  TProgramAddress,
  TAccountSettlementAuthority,
  TAccountInitializerProgram,
  TAccountInitializerConfig,
  TAccountLaunch,
  TAccountLaunchFeeState,
  TAccountLaunchAuthority,
  TAccountBaseMint,
  TAccountQuoteMint,
  TAccountBaseVault,
  TAccountQuoteVault,
  TAccountRehypeState,
  TAccountRehypeAuthority,
  TAccountSettlementSigner,
  TAccountRouterBaseAta,
  TAccountRouterQuoteAta,
  TAccountBuybackDestination,
  TAccountBuybackBaseAta,
  TAccountBuybackQuoteAta,
  TAccountNamespace,
  TAccountHookConfig,
  TAccountHookProgram,
  TAccountBaseTokenProgram,
  TAccountQuoteTokenProgram,
  TAccountAssociatedTokenProgram,
  TAccountSystemProgram,
  TAccountGateCosigner,
  TAccountCosignGateControl
> {
  // Program address.
  const programAddress =
    config?.programAddress ?? DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    settlementAuthority: {
      value: input.settlementAuthority ?? null,
      isWritable: true,
    },
    initializerProgram: {
      value: input.initializerProgram ?? null,
      isWritable: false,
    },
    initializerConfig: {
      value: input.initializerConfig ?? null,
      isWritable: false,
    },
    launch: { value: input.launch ?? null, isWritable: true },
    launchFeeState: { value: input.launchFeeState ?? null, isWritable: true },
    launchAuthority: {
      value: input.launchAuthority ?? null,
      isWritable: false,
    },
    baseMint: { value: input.baseMint ?? null, isWritable: false },
    quoteMint: { value: input.quoteMint ?? null, isWritable: false },
    baseVault: { value: input.baseVault ?? null, isWritable: true },
    quoteVault: { value: input.quoteVault ?? null, isWritable: true },
    rehypeState: { value: input.rehypeState ?? null, isWritable: true },
    rehypeAuthority: {
      value: input.rehypeAuthority ?? null,
      isWritable: false,
    },
    settlementSigner: {
      value: input.settlementSigner ?? null,
      isWritable: false,
    },
    routerBaseAta: { value: input.routerBaseAta ?? null, isWritable: true },
    routerQuoteAta: { value: input.routerQuoteAta ?? null, isWritable: true },
    buybackDestination: {
      value: input.buybackDestination ?? null,
      isWritable: false,
    },
    buybackBaseAta: { value: input.buybackBaseAta ?? null, isWritable: true },
    buybackQuoteAta: { value: input.buybackQuoteAta ?? null, isWritable: true },
    namespace: { value: input.namespace ?? null, isWritable: false },
    hookConfig: { value: input.hookConfig ?? null, isWritable: false },
    hookProgram: { value: input.hookProgram ?? null, isWritable: false },
    baseTokenProgram: {
      value: input.baseTokenProgram ?? null,
      isWritable: false,
    },
    quoteTokenProgram: {
      value: input.quoteTokenProgram ?? null,
      isWritable: false,
    },
    associatedTokenProgram: {
      value: input.associatedTokenProgram ?? null,
      isWritable: false,
    },
    systemProgram: { value: input.systemProgram ?? null, isWritable: false },
    gateCosigner: { value: input.gateCosigner ?? null, isWritable: false },
    cosignGateControl: {
      value: input.cosignGateControl ?? null,
      isWritable: false,
    },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Original args.
  const args = { ...input };

  // Resolve default values.
  if (!accounts.initializerProgram.value) {
    accounts.initializerProgram.value =
      '4h3Dqyo5qmteJoMxXt3tdtfXELDB6pdRTPU9mWruiKp1' as Address<'4h3Dqyo5qmteJoMxXt3tdtfXELDB6pdRTPU9mWruiKp1'>;
  }
  if (!accounts.associatedTokenProgram.value) {
    accounts.associatedTokenProgram.value =
      'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL' as Address<'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'>;
  }
  if (!accounts.systemProgram.value) {
    accounts.systemProgram.value =
      '11111111111111111111111111111111' as Address<'11111111111111111111111111111111'>;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('settlementAuthority', accounts.settlementAuthority),
      getAccountMeta('initializerProgram', accounts.initializerProgram),
      getAccountMeta('initializerConfig', accounts.initializerConfig),
      getAccountMeta('launch', accounts.launch),
      getAccountMeta('launchFeeState', accounts.launchFeeState),
      getAccountMeta('launchAuthority', accounts.launchAuthority),
      getAccountMeta('baseMint', accounts.baseMint),
      getAccountMeta('quoteMint', accounts.quoteMint),
      getAccountMeta('baseVault', accounts.baseVault),
      getAccountMeta('quoteVault', accounts.quoteVault),
      getAccountMeta('rehypeState', accounts.rehypeState),
      getAccountMeta('rehypeAuthority', accounts.rehypeAuthority),
      getAccountMeta('settlementSigner', accounts.settlementSigner),
      getAccountMeta('routerBaseAta', accounts.routerBaseAta),
      getAccountMeta('routerQuoteAta', accounts.routerQuoteAta),
      getAccountMeta('buybackDestination', accounts.buybackDestination),
      getAccountMeta('buybackBaseAta', accounts.buybackBaseAta),
      getAccountMeta('buybackQuoteAta', accounts.buybackQuoteAta),
      getAccountMeta('namespace', accounts.namespace),
      getAccountMeta('hookConfig', accounts.hookConfig),
      getAccountMeta('hookProgram', accounts.hookProgram),
      getAccountMeta('baseTokenProgram', accounts.baseTokenProgram),
      getAccountMeta('quoteTokenProgram', accounts.quoteTokenProgram),
      getAccountMeta('associatedTokenProgram', accounts.associatedTokenProgram),
      getAccountMeta('systemProgram', accounts.systemProgram),
      getAccountMeta('gateCosigner', accounts.gateCosigner),
      getAccountMeta('cosignGateControl', accounts.cosignGateControl),
    ],
    data: getSettleFeesInstructionDataEncoder().encode(
      args as SettleFeesInstructionDataArgs,
    ),
    programAddress,
  } as SettleFeesInstruction<
    TProgramAddress,
    TAccountSettlementAuthority,
    TAccountInitializerProgram,
    TAccountInitializerConfig,
    TAccountLaunch,
    TAccountLaunchFeeState,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountRehypeState,
    TAccountRehypeAuthority,
    TAccountSettlementSigner,
    TAccountRouterBaseAta,
    TAccountRouterQuoteAta,
    TAccountBuybackDestination,
    TAccountBuybackBaseAta,
    TAccountBuybackQuoteAta,
    TAccountNamespace,
    TAccountHookConfig,
    TAccountHookProgram,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram,
    TAccountAssociatedTokenProgram,
    TAccountSystemProgram,
    TAccountGateCosigner,
    TAccountCosignGateControl
  >);
}

export type ParsedSettleFeesInstruction<
  TProgram extends string = typeof DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS,
  TAccountMetas extends readonly AccountMeta[] = readonly AccountMeta[],
> = {
  programAddress: Address<TProgram>;
  accounts: {
    settlementAuthority: TAccountMetas[0];
    initializerProgram: TAccountMetas[1];
    initializerConfig: TAccountMetas[2];
    launch: TAccountMetas[3];
    launchFeeState: TAccountMetas[4];
    launchAuthority: TAccountMetas[5];
    baseMint: TAccountMetas[6];
    quoteMint: TAccountMetas[7];
    baseVault: TAccountMetas[8];
    quoteVault: TAccountMetas[9];
    rehypeState: TAccountMetas[10];
    rehypeAuthority: TAccountMetas[11];
    settlementSigner: TAccountMetas[12];
    routerBaseAta: TAccountMetas[13];
    routerQuoteAta: TAccountMetas[14];
    buybackDestination: TAccountMetas[15];
    buybackBaseAta: TAccountMetas[16];
    buybackQuoteAta: TAccountMetas[17];
    namespace: TAccountMetas[18];
    hookConfig: TAccountMetas[19];
    hookProgram: TAccountMetas[20];
    baseTokenProgram: TAccountMetas[21];
    quoteTokenProgram: TAccountMetas[22];
    associatedTokenProgram: TAccountMetas[23];
    systemProgram: TAccountMetas[24];
    gateCosigner?: TAccountMetas[25] | undefined;
    cosignGateControl?: TAccountMetas[26] | undefined;
  };
  data: SettleFeesInstructionData;
};

export function parseSettleFeesInstruction<
  TProgram extends string,
  TAccountMetas extends readonly AccountMeta[],
>(
  instruction: Instruction<TProgram> &
    InstructionWithAccounts<TAccountMetas> &
    InstructionWithData<ReadonlyUint8Array>,
): ParsedSettleFeesInstruction<TProgram, TAccountMetas> {
  if (instruction.accounts.length < 27) {
    throw new SolanaError(
      SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
      {
        actualAccountMetas: instruction.accounts.length,
        expectedAccountMetas: 27,
      },
    );
  }
  let accountIndex = 0;
  const getNextAccount = () => {
    const accountMeta = (instruction.accounts as TAccountMetas)[accountIndex]!;
    accountIndex += 1;
    return accountMeta;
  };
  const getNextOptionalAccount = () => {
    const accountMeta = getNextAccount();
    return accountMeta.address === DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS
      ? undefined
      : accountMeta;
  };
  return {
    programAddress: instruction.programAddress,
    accounts: {
      settlementAuthority: getNextAccount(),
      initializerProgram: getNextAccount(),
      initializerConfig: getNextAccount(),
      launch: getNextAccount(),
      launchFeeState: getNextAccount(),
      launchAuthority: getNextAccount(),
      baseMint: getNextAccount(),
      quoteMint: getNextAccount(),
      baseVault: getNextAccount(),
      quoteVault: getNextAccount(),
      rehypeState: getNextAccount(),
      rehypeAuthority: getNextAccount(),
      settlementSigner: getNextAccount(),
      routerBaseAta: getNextAccount(),
      routerQuoteAta: getNextAccount(),
      buybackDestination: getNextAccount(),
      buybackBaseAta: getNextAccount(),
      buybackQuoteAta: getNextAccount(),
      namespace: getNextAccount(),
      hookConfig: getNextAccount(),
      hookProgram: getNextAccount(),
      baseTokenProgram: getNextAccount(),
      quoteTokenProgram: getNextAccount(),
      associatedTokenProgram: getNextAccount(),
      systemProgram: getNextAccount(),
      gateCosigner: getNextOptionalAccount(),
      cosignGateControl: getNextOptionalAccount(),
    },
    data: getSettleFeesInstructionDataDecoder().decode(instruction.data),
  };
}
